import { useState, useRef, useEffect } from "react";
import api from "../api";
import { guardarMarca } from "../marca";
import { useTheme } from "../components/Theme";
import Permissoes from "./Permissoes";

const ORANGE = "#FF6B2B";

// Componente de upload de imagem
function ImageUploader({ atual, onUpload, label, tipo, shape="circle", size=100 }) {
  const { theme } = useTheme();
  const [load, setLoad]     = useState(false);
  const [preview, setPreview] = useState(atual||null);
  const [error, setError]   = useState("");
  const inputRef = useRef();

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Preview local imediato
    const reader = new FileReader();
    reader.onload = (ev) => setPreview(ev.target.result);
    reader.readAsDataURL(file);

    setLoad(true); setError("");
    try {
      const form = new FormData();
      form.append("imagem", file);
      const { data } = await api.post(`/upload/${tipo}`, form, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      onUpload(data.url);
    } catch(e) {
      setError(e.response?.data?.erro || "Erro ao enviar imagem");
      setPreview(atual);
    } finally { setLoad(false); }
  };

  const borderRadius = shape === "circle" ? "50%" : 12;

  return (
    <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:12 }}>
      <div style={{ position:"relative", cursor:"pointer" }} onClick={()=>inputRef.current?.click()}>
        {/* Imagem atual ou placeholder */}
        <div style={{ width:size, height:size, borderRadius, background:theme.bgInput, border:`2px dashed ${load?ORANGE:theme.border}`, display:"flex", alignItems:"center", justifyContent:"center", overflow:"hidden", transition:"border-color .2s" }}>
          {preview ? (
            <img src={preview} alt={label} style={{ width:"100%", height:"100%", objectFit:"cover" }}/>
          ) : (
            <div style={{ textAlign:"center", padding:8 }}>
              <div style={{ fontSize:shape==="circle"?28:36, marginBottom:4 }}>{shape==="circle"?"👤":"🏢"}</div>
              <div style={{ fontSize:10, color:theme.textMuted }}>Clique para<br/>adicionar</div>
            </div>
          )}
        </div>

        {/* Overlay ao hover */}
        <div style={{ position:"absolute", inset:0, borderRadius, background:"rgba(0,0,0,.5)", display:"flex", alignItems:"center", justifyContent:"center", opacity:0, transition:"opacity .2s" }}
          onMouseEnter={e=>e.currentTarget.style.opacity=1}
          onMouseLeave={e=>e.currentTarget.style.opacity=0}>
          <div style={{ textAlign:"center" }}>
            {load ? <div style={{ color:"#fff", fontSize:24 }}>⏳</div> : <>
              <div style={{ color:"#fff", fontSize:22 }}>📷</div>
              <div style={{ color:"#fff", fontSize:11, marginTop:4 }}>Alterar</div>
            </>}
          </div>
        </div>
      </div>

      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} style={{ display:"none" }}/>

      <div style={{ textAlign:"center" }}>
        <button onClick={()=>inputRef.current?.click()} disabled={load}
          style={{ background:ORANGE+"22", border:`1px solid ${ORANGE}44`, borderRadius:8, padding:"6px 16px", color:ORANGE, fontSize:12, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',sans-serif" }}>
          {load ? "Enviando..." : `Alterar ${label.toLowerCase()}`}
        </button>
        {preview && (
          <button onClick={()=>{ setPreview(null); onUpload(null); }}
            style={{ background:"none", border:"none", color:theme.textMuted, fontSize:11, cursor:"pointer", display:"block", marginTop:4, textDecoration:"underline" }}>
            Remover
          </button>
        )}
      </div>

      {error && <div style={{ fontSize:12, color:"#ef4444", textAlign:"center" }}>{error}</div>}
      <div style={{ fontSize:11, color:theme.textMuted, textAlign:"center" }}>JPG, PNG, GIF, WebP ou SVG · Máx 5MB</div>
    </div>
  );
}

export default function Configuracoes({ user, onUserUpdate, currentUser }) {
  const { theme } = useTheme();
  const [abaConfig, setAbaConfig] = useState("perfil");
  const [nome,  setNome]  = useState(user?.nome||"");
  const [email, setEmail] = useState(user?.email||"");
  const [senhaAtual,   setSenhaAtual]   = useState("");
  const [novaSenha,    setNovaSenha]    = useState("");
  const [confirmSenha, setConfirmSenha] = useState("");
  const [agencia, setAgencia] = useState(()=>{ try{return JSON.parse(localStorage.getItem("agencia_dados"))||{};}catch{return{};} });
  const [toast, setToast] = useState({msg:"",type:""});
  const [load,  setLoad]  = useState("");

  const inp = { width:"100%", boxSizing:"border-box", background:theme.bgInput, border:`1.5px solid ${theme.border}`, borderRadius:10, padding:"9px 12px", color:theme.text, fontSize:14, outline:"none", colorScheme:theme.name, fontFamily:"'Inter',sans-serif", transition:"border-color .15s" };
  const showToast=(msg,type="ok")=>{ setToast({msg,type}); setTimeout(()=>setToast({msg:"",type:""}),3500); };
  const setAg=(k,v)=>setAgencia(a=>({...a,[k]:v}));

  const salvarPerfil=async()=>{
    setLoad("perfil");
    try{
      await api.put(`/users/${user._id}`,{nome,email});
      const u={...user,nome,email};
      localStorage.setItem("crm_user",JSON.stringify(u));
      if(onUserUpdate) onUserUpdate(u);
      showToast("Perfil atualizado!");
    }catch(e){ showToast(e.response?.data?.erro||"Erro ao salvar","erro"); }
    finally{setLoad("");}
  };

  const salvarSenha=async()=>{
    if(novaSenha!==confirmSenha) return showToast("As senhas não coincidem","erro");
    if(novaSenha.length<6) return showToast("Mínimo 6 caracteres","erro");
    setLoad("senha");
    try{
      await api.put("/users/me/senha",{senhaAtual,novaSenha});
      setSenhaAtual("");setNovaSenha("");setConfirmSenha("");
      showToast("Senha alterada!");
    }catch(e){ showToast(e.response?.data?.erro||"Erro","erro"); }
    finally{setLoad("");}
  };

  useEffect(()=>{
    api.get("/empresa").then(({data})=>{
      if(data){
        setAgencia(data);
        localStorage.setItem("agencia_dados",JSON.stringify(data));
        window.dispatchEvent(new CustomEvent("agencia_atualizada", { detail: data }));
      }
    }).catch(()=>{});
  },[]);

  const salvarAgencia=async()=>{
    try{
      const { data } = await api.put("/empresa", agencia); guardarMarca(data || agencia);
      setAgencia(data);
      localStorage.setItem("agencia_dados",JSON.stringify(data));
      window.dispatchEvent(new CustomEvent("agencia_atualizada", { detail: data }));
      showToast("Dados da agência salvos!");
    }catch(e){ showToast("Erro ao salvar dados da agência","erro"); }
  };

  const handleAvatarUpload = (url) => {
    const u = { ...user, avatar: url };
    localStorage.setItem("crm_user", JSON.stringify(u));
    if (onUserUpdate) onUserUpdate(u);
    showToast("Foto de perfil atualizada!");
  };

  const handleLogoUpload = async (url) => {
    const nova = { ...agencia, logo: url };
    setAgencia(nova);
    localStorage.setItem("agencia_dados", JSON.stringify(nova));
    window.dispatchEvent(new CustomEvent("agencia_atualizada", { detail: nova }));
    try{ await api.put("/empresa", { logo: url }); }catch(e){}
    showToast("Logo atualizada!");
  };

  const ABAS_CONFIG = [
    { id:"perfil",      label:"👤 Meu Perfil",     show: true },
    
    { id:"senha",       label:"🔒 Senha",           show: true },
    { id:"agencia",     label:"🏢 Agência",         show: true },
    { id:"permissoes",  label:"🔐 Permissões",      show: (currentUser||user)?.role==="admin" },
  ].filter(a=>a.show);

  return (
    <div style={{ padding:"24px 28px", fontFamily:"'Inter',-apple-system,sans-serif", background:theme.bg, minHeight:"100vh" }}>
      {toast.msg&&(
        <div style={{ position:"fixed", bottom:24, right:24, background:(toast.type==="erro"?"#ef4444":"#10b981")+"22", border:`1px solid ${(toast.type==="erro"?"#ef4444":"#10b981")}44`, borderRadius:10, padding:"12px 20px", color:toast.type==="erro"?"#ef4444":"#10b981", fontSize:13, fontWeight:600, zIndex:2000 }}>
          {toast.type==="erro"?"❌":"✅"} {toast.msg}
        </div>
      )}

      {/* Abas */}
      <div style={{ display:"flex", gap:4, marginBottom:28, borderBottom:`1px solid ${theme.border}`, flexWrap:"wrap" }}>
        {ABAS_CONFIG.map(a=>(
          <button key={a.id} onClick={()=>setAbaConfig(a.id)} style={{ padding:"10px 18px", borderRadius:"10px 10px 0 0", fontSize:13, fontWeight:abaConfig===a.id?700:400, cursor:"pointer", border:"none", borderBottom:abaConfig===a.id?`2px solid ${ORANGE}`:"2px solid transparent", background:"transparent", color:abaConfig===a.id?ORANGE:theme.textMuted, fontFamily:"'Inter',sans-serif", marginBottom:-1 }}>
            {a.label}
          </button>
        ))}
      </div>

      {/* ── PERFIL ── */}
      {abaConfig==="perfil" && (
        <div style={{ maxWidth:560 }}>
          <h3 style={{ margin:"0 0 24px", fontSize:18, fontWeight:700, color:theme.text }}>Meu Perfil</h3>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:20 }}>
            {[["Nome completo","nome",nome,setNome,"text"],["Email","email",email,setEmail,"email"]].map(([label,key,val,setter,type])=>(
              <div key={key}>
                <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:5, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
                <input type={type} value={val} onChange={e=>setter(e.target.value)} style={inp}
                  onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
              </div>
            ))}
          </div>
          <button onClick={salvarPerfil} disabled={load==="perfil"} style={{ background:`linear-gradient(135deg,${ORANGE},#FF9A5C)`, border:"none", borderRadius:10, padding:"11px 24px", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"'Inter',sans-serif", opacity:load==="perfil"?.7:1 }}>
            {load==="perfil"?"Salvando...":"Salvar perfil"}
          </button>
        </div>
      )}

      {/* ── APARÊNCIA ── */}
      {abaConfig==="aparencia" && (
        <div style={{ maxWidth:640 }}>
          <h3 style={{ margin:"0 0 24px", fontSize:18, fontWeight:700, color:theme.text }}>Aparência</h3>

          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:32 }}>
            {/* Foto de perfil */}
            <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:14, padding:24, textAlign:"center" }}>
              <h4 style={{ margin:"0 0 20px", fontSize:14, fontWeight:700, color:theme.text }}>Foto de perfil</h4>
              <ImageUploader
                atual={user?.avatar}
                onUpload={handleAvatarUpload}
                label="Foto"
                tipo="avatar"
                shape="circle"
                size={110}
              />
              <p style={{ fontSize:12, color:theme.textMuted, marginTop:12, lineHeight:1.5 }}>
                Sua foto aparece no sidebar e nos registros de atividade.
              </p>
            </div>

            {/* Logo da agência */}
            <div style={{ background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:14, padding:24, textAlign:"center" }}>
              <h4 style={{ margin:"0 0 20px", fontSize:14, fontWeight:700, color:theme.text }}>Logo da agência</h4>
              <ImageUploader
                atual={agencia.logo}
                onUpload={handleLogoUpload}
                label="Logo"
                tipo="logo"
                shape="rounded"
                size={110}
              />
              <p style={{ fontSize:12, color:theme.textMuted, marginTop:12, lineHeight:1.5 }}>
                A logo aparece no sidebar e na tela de login.
              </p>
            </div>
          </div>

          {/* Preview do sidebar */}
          <div style={{ marginTop:24, background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:14, padding:20 }}>
            <h4 style={{ margin:"0 0 16px", fontSize:13, fontWeight:700, color:theme.text }}>Preview — Como vai aparecer no sidebar</h4>
            <div style={{ background:theme.bgSecond, borderRadius:10, padding:12, display:"flex", alignItems:"center", gap:10, width:"fit-content", border:`1px solid ${theme.border}` }}>
              {/* Logo */}
              <div style={{ width:34, height:34, borderRadius:10, overflow:"hidden", background:agencia.logo?theme.bgInput:`linear-gradient(135deg,${ORANGE},#FF9A5C)`, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                {agencia.logo
                  ? <img src={agencia.logo} alt="logo" style={{ width:"100%", height:"100%", objectFit:"cover" }}/>
                  : <span style={{ fontSize:18 }}>⚡</span>
                }
              </div>
              <div>
                <div style={{ fontSize:13, fontWeight:800, color:theme.text }}>{agencia.nome||"Sua empresa"}</div>
                <div style={{ fontSize:10, color:theme.textMuted }}>CRM de Vendas</div>
              </div>
            </div>

            {/* Perfil no sidebar */}
            <div style={{ marginTop:12, background:theme.bgInput, borderRadius:10, padding:"10px 12px", display:"flex", alignItems:"center", gap:10, width:"fit-content" }}>
              <div style={{ width:32, height:32, borderRadius:10, overflow:"hidden", background:ORANGE+"25", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                {user?.avatar
                  ? <img src={user.avatar} alt="avatar" style={{ width:"100%", height:"100%", objectFit:"cover", borderRadius:10 }}/>
                  : <span style={{ fontSize:16 }}>⚡</span>
                }
              </div>
              <div>
                <div style={{ fontSize:13, fontWeight:600, color:theme.text }}>{user?.nome?.split(" ")[0]||"Adriano"}</div>
                <div style={{ fontSize:11, color:ORANGE }}>Admin</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── SENHA ── */}
      {abaConfig==="senha" && (
        <div style={{ maxWidth:560 }}>
          <h3 style={{ margin:"0 0 24px", fontSize:18, fontWeight:700, color:theme.text }}>Alterar Senha</h3>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:14, marginBottom:20 }}>
            {[["Senha atual",senhaAtual,setSenhaAtual],["Nova senha",novaSenha,setNovaSenha],["Confirmar",confirmSenha,setConfirmSenha]].map(([label,val,setter])=>(
              <div key={label}>
                <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:5, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
                <input type="password" value={val} onChange={e=>setter(e.target.value)} style={inp}
                  onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
              </div>
            ))}
          </div>
          <button onClick={salvarSenha} disabled={load==="senha"} style={{ background:"#6366f1", border:"none", borderRadius:10, padding:"11px 24px", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"'Inter',sans-serif", opacity:load==="senha"?.7:1 }}>
            {load==="senha"?"Alterando...":"Alterar senha"}
          </button>
        </div>
      )}

      {/* ── AGÊNCIA ── */}
      {abaConfig==="agencia" && (
        <div style={{ maxWidth:640 }}>
          <h3 style={{ margin:"0 0 24px", fontSize:18, fontWeight:700, color:theme.text }}>Dados da Agência</h3>
          <div style={{ display:"flex", alignItems:"center", gap:20, marginBottom:24, padding:18, background:theme.bgCard, border:`1px solid ${theme.border}`, borderRadius:14 }}>
            <ImageUploader
              atual={agencia.logo}
              onUpload={handleLogoUpload}
              label="Logo"
              tipo="logo"
              shape="rounded"
              size={90}
            />
            <div>
              <div style={{ fontSize:14, fontWeight:700, color:theme.text, marginBottom:4 }}>Logo da empresa</div>
              <p style={{ fontSize:12, color:theme.textMuted, margin:0, lineHeight:1.5 }}>
                Aparece no cabeçalho dos orçamentos em PDF, no sidebar e na tela de login.<br/>PNG com fundo transparente é o ideal.
              </p>
            </div>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:14, marginBottom:20 }}>
            {[
              ["Nome da empresa","nome","Sua Empresa Ltda"],
              ["Razão social","razaoSocial","Sua Empresa Ltda"],
              ["Inscrição estadual","inscricaoEstadual","Isento"],
              ["CEP","cep","00000-000"],
              ["Nº inicial dos orçamentos","orcamentoNumeroInicial","1"],
              ["Slogan (PDF)","slogan","O slogan da sua empresa"],
              ["Áreas de atuação (PDF)","areasAtuacao","Área 1, Área 2, Área 3"],
              ["Contatos rodapé (PDF) — separe por ;","contatos","Fulano - email; (00) 00000-0000"],
              ["CNPJ","cnpj","00.000.000/0001-00"],
              ["Telefone","telefone","(00) 00000-0000"],
              ["Email comercial","emailComercial","contato@suaempresa.com.br"],
              ["Site","site","suaempresa.com.br"],
              ["Instagram","instagram","@suaempresa"],
              ["Cidade / Estado","cidade","Cidade, UF"],
              ["Endereço","endereco","Rua Exemplo, 123"],
            ].map(([label,key,placeholder])=>(
              <div key={key}>
                <label style={{ fontSize:11, color:theme.textMuted, display:"block", marginBottom:5, fontWeight:600, letterSpacing:".04em", textTransform:"uppercase" }}>{label}</label>
                <input value={agencia[key]||""} onChange={e=>setAg(key,e.target.value)} placeholder={placeholder} style={inp}
                  onFocus={e=>e.target.style.borderColor=ORANGE} onBlur={e=>e.target.style.borderColor=theme.border}/>
              </div>
            ))}
          </div>
          <button onClick={salvarAgencia} style={{ background:"#10b981", border:"none", borderRadius:10, padding:"11px 24px", color:"#fff", fontWeight:700, fontSize:14, cursor:"pointer", fontFamily:"'Inter',sans-serif" }}>
            Salvar dados
          </button>
        </div>
      )}

      {/* ── PERMISSÕES ── */}
      {abaConfig==="permissoes" && <Permissoes currentUser={currentUser||user}/>}
    </div>
  );
}
